import { render, staticRenderFns } from "./Remain_Unmatched.vue?vue&type=template&id=64d93713&scoped=true"
import script from "./Remain_Unmatched.vue?vue&type=script&lang=js"
export * from "./Remain_Unmatched.vue?vue&type=script&lang=js"
import style0 from "./Remain_Unmatched.vue?vue&type=style&index=0&id=64d93713&prod&scoped=true&lang=css"
import style1 from "./Remain_Unmatched.vue?vue&type=style&index=1&id=64d93713&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d93713",
  null
  
)

export default component.exports